// extracted by mini-css-extract-plugin
export var header = "_be-0";